import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';
import VTooltip from 'v-tooltip'
import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";
import "@egjs/flicking-plugins/dist/flicking-plugins.css";

Vue.use(Flicking);
Vue.directive('click-outside', {
  bind: function (element, binding, vnode) {
    element.clickOutsideEvent = function (event) {  //  check that click was outside the element and his children
      if (!(element === event.target || element.contains(event.target))) { // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', element.clickOutsideEvent)
  },
  unbind: function (element) {
    document.body.removeEventListener('click', element.clickOutsideEvent)
  }
});

Vue.filter('filterValue', (option) => {
  // Used to split the filter tag and just get the avalue
  return option.split('_').pop();
});

Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click'
})

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');
Vue.filter('getProductImageSecond', product => (product.images.length > 1) ? product.images[1].src : ((product.images.length > 0) ? product.images[0].src : ''));

Vue.filter('getProductVariantImage', function (product,variantId){
  var productVariantImage = product.variants.find(x => x.id == variantId).featured_image;
  if(productVariantImage){
    return productVariantImage.src;
  }
  return (product.images.length > 0) ? product.images[0].src : '';
  });

  Vue.filter('getCurrentProductImage', function(product){
    var productVariantImage = product.variants[0].featured_image;
    if(productVariantImage){
      return productVariantImage.src;
    }
    return (product.images.length > 0) ? product.images[0].src : '';
  });

Vue.filter('getProductDesc', product => {
  var desc = product.body_html.replace( /(<([^>]+)>)/ig, '');
  return desc.replaceAll('&amp;','&').replaceAll('&nbsp;',' ');
});

Vue.filter('getAltImage', product => product.images[1].src);

Vue.filter('moneyFormat', (product) => {
  if (product.variants) {
    return `$${product.variants[0].price}`;
  }
  return '';
});

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('moneySaleFormat', (price) => {
  if (price != null) {
    return `$${parseFloat(price).toFixed(2)}`;
  }
  return '';
});

Vue.filter('boxTheme', (product) => {
  if (product) {
    var theme = product.tags.find(x => x.includes("Occasion_"))
    return theme.split("_")[1];
  }
  return '';
});

/* eslint-disable no-unused-vars */
const BuildABoxApp = new Vue({
  el: '#BuildABox',
  data: {
    currentPage: 1,
  },
  store,
  created() {
    this.$store.dispatch('getFeeProduct');
    this.$store.dispatch('getProducts');
    // this.$store.dispatch('getCuratedBox');
  },
  render: h => h(App),
});
